import Link from "next/link";
import Image from "next/image";
import React, { useState } from "react";
import SampleRequestModal from "@/components/Products/SampleRequestModal";
import { getCDNImageUrl, slugify } from "@/utils/Common";

const FALLBACK_IMAGE = getCDNImageUrl("dummy-product-image.webp");

export default function FaqHubProductSummary({ product, pageTitle }) {
  const [sampleOpen, setSampleOpen] = useState(false);

  if (!product?.id) return null;

  const name = pageTitle || product.ChemicalName || "";
  const brandLine = product.Brand_Name || "";
  const pdpHref = `/product/${slugify(name)}-${product.id}?utm_source=faq_hub`;
  const img =
    product.image ||
    product.ProductImage ||
    product.image_url ||
    FALLBACK_IMAGE;

  const desc = product.Productdescription;

  return (
    <section className="flex flex-col md:flex-row items-stretch gap-5">
      <div className="flex-1 min-w-0 rounded-[14px] bg-[#ededed] px-5 py-5 md:px-7 md:py-7 order-2 md:order-1">
        {product.is_topProduct ? (
          <span className="inline-flex items-center gap-1.5 rounded-[6px] bg-[#e5def7] px-2 py-0.5 font-mukta text-[0.68rem] font-semibold text-[#5b21b6]">
            <Image
              src="/assets/icons/star.svg"
              alt=""
              width={10}
              height={10}
              aria-hidden
            />
            Top Product
          </span>
        ) : null}

        <h1
          className={`font-mukta text-[1.4rem] md:text-[1.65rem] font-semibold leading-tight text-[#161616] ${
            product.is_topProduct ? "mt-3" : ""
          }`}
        >
          {name}
        </h1>
        {brandLine ? (
          <p className="mt-1 font-mukta text-[0.95rem] text-[#3f3f3f]">
            {brandLine}
          </p>
        ) : null}

        {desc ? (
          <p className="mt-4 font-mukta text-[0.88rem] leading-relaxed text-[#4d4d4d]">
            {desc}
          </p>
        ) : null}

        <dl className="mt-5 flex flex-wrap gap-x-12 gap-y-2 font-mukta text-[0.8rem]">
          <div>
            <dt className="text-[#8a8a8a]">CAS Number</dt>
            <dd className="mt-0.5 font-medium text-[#161616]">
              {product.CasNumber || "—"}
            </dd>
          </div>
          {/* <div>
            <dt className="text-[#8a8a8a]">EC Number</dt>
            <dd className="mt-0.5 font-medium text-[#161616]">
              {product.EcNumber || "—"}
            </dd>
          </div> */}
        </dl>

        <div className="mt-5 flex flex-wrap items-center gap-3">
          <Link
            href={pdpHref}
            className="inline-flex cursor-pointer items-center justify-center rounded-[6px] bg-[#ef4136] px-4 py-2.5 font-mukta text-[0.82rem] font-medium text-white hover:!text-white focus-visible:!text-white active:!text-white"
          >
            View Product Details
          </Link>
          <button
            type="button"
            onClick={() => setSampleOpen(true)}
            className="inline-flex items-center justify-center rounded-[6px] border border-[#ef4136] bg-transparent px-4 py-2.5 font-mukta text-[0.82rem] font-medium text-[#ef4136] hover:bg-[#fff5f4] transition-colors"
          >
            Request Sample/Quote
          </button>
          <SampleRequestModal
            open={sampleOpen}
            onClose={() => setSampleOpen(false)}
            productName={name}
            brandName={product?.Brand_Name || ""}
          />
        </div>
      </div>

      <div className="order-1 md:order-2 w-full md:w-[360px] lg:w-[400px] shrink-0 self-stretch overflow-hidden rounded-[14px] border border-[#e4e4e4] bg-white">
        <img
          src={img}
          alt={name}
          className="block h-[220px] md:h-full w-full object-cover md:min-h-[340px]"
        />
      </div>
    </section>
  );
}
